import { useEffect, useRef, useState } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';

// material-ui
import { alpha, useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import ButtonBase from '@mui/material/ButtonBase';
import Chip from '@mui/material/Chip';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import Stack from '@mui/material/Stack';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// types
import { MenuOrientation, ThemeMode } from 'types/config';
import { LinkTarget, NavItemType } from 'types';
import Skeleton from '@mui/material/Skeleton';

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //



const Navitems = styled(Stack)(({ theme }) => ({
    '.sidebarmenu':{
        ':hover':{
            'img':{
            filter: 'invert(100%)',
            },
            'p':{
                color:'#fff'
            }
        }
    }
}));



interface NavItemProps {
    item: NavItemType;
    level: number;
    isParents?: boolean;
    setSelectedID?: () => void;
}

const NavItem = ({ item, level, isParents = false, setSelectedID }: NavItemProps) => {
    const theme = useTheme();
    const downMD = useMediaQuery(theme.breakpoints.down('md'));
    const ref = useRef<HTMLSpanElement>(null);

    const { pathname } = useLocation();
    const { mode, menuOrientation, borderRadius } = useConfig();

    const { menuMaster } = useGetMenuMaster();
    const drawerOpen = menuMaster.isDashboardDrawerOpened;
    const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downMD;
    const isSelected = !!matchPath({ path: item?.link ? item.link : item.url!, end: false }, pathname);

    const [hoverStatus, setHover] = useState<boolean>(false);
    const [loading, setLoading] = useState(true);

    const compareSize = () => {
        const compare = ref.current && ref.current.scrollWidth > ref.current.clientWidth;
        setHover(compare as boolean);
    };

    useEffect(() => {
        compareSize();
        window.addEventListener('resize', compareSize);
        window.removeEventListener('resize', compareSize);
    }, []);

    useEffect(() => {
        // Simulate an API call or data fetching
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000); // Adjust the timeout as needed

        return () => clearTimeout(timer);
        // const downMD = useMediaQuery(theme.breakpoints.down('md'));
    }, []);

    const Icon = item?.icon!;
    const itemIcon = item?.icon && (
        <Icon
            stroke={1.5}
            size={drawerOpen ? '20px' : '24px'}
            style={{ ...(isHorizontal && isParents && { fontSize: 20, stroke: '1.5' }) }}
        />
    );

    let itemTarget: LinkTarget = '_self';
    if (item.target) {
        itemTarget = '_blank';
    }

    const itemHandler = () => {
        if (downMD) handlerDrawerOpen(false);

        if (isParents && setSelectedID) {
            setSelectedID();
        }
    };

    const iconSelectedColor = mode === ThemeMode.DARK && drawerOpen ? 'text.primary' : '#fff';
    return (
        <>
           <Navitems>
            {!isHorizontal ? (
                <ListItemButton
                    component={Link}
                    to={item.url!}
                    target={itemTarget}
                    disabled={item.disabled}
                    disableRipple={!drawerOpen}
                    className='sidebarmenu'
                    
                    
                    sx={{
                        zIndex: 1201,
                        //bgcolor: 'transparent',
                        borderRadius: `0px`,
                        backgroundColor: theme.palette.common.white,

                        // borderRadius: `${borderRadius}px`,
                        // mb: '1px',
                        p: 0.8,
                        color: '#212121',
                        // borderBottom:'1px solid #d4e8e1',
                        mb: '1px',
                        // ':hover':{ backgroundColor: alpha(theme.palette.secondary.main, 1), color:'#fff'},

                        pl: drawerOpen ? `${level * 10}px` : 1.25,
                        ...(drawerOpen &&
                            level === 1 &&
                            mode !== ThemeMode.DARK && {
                                // borderBottom:'1px solid #d4e8e1',
                                background: '#fff',
                                '@media (max-width: 568px)': {
                                    background: '#ff0000'
                                },
                                '&:hover': {
                                    //bgcolor: 'secondary.light',
                                    bgcolor: '#ff0000',
                                    color: '#fff',
                                    '.svgimg': {}
                                },
                                '&.Mui-selected': {
                                    //bgcolor: 'secondary.light',
                                    bgcolor: '#10B981',
                                    color: '#fff',
                                    fontWeight: '600',
                                    '&:hover': {
                                        color: iconSelectedColor,
                                        // bgcolor: 'secondary.light'
                                        bgcolor: '#10B981'
                                    }
                                }
                            }),
                        ...((!drawerOpen || level !== 1) && {
                            py: level === 1 ? 0 : 1,
                            backgroundColor: 'transparent',
                            '&:hover': {
                                bgcolor: 'transparent'
                            },
                            '&.Mui-selected': {
                                '&:hover': {
                                    bgcolor: 'transparent'
                                },
                                bgcolor: 'transparent'
                            }
                        })
                    }}
                    selected={isSelected}
                    onClick={() => itemHandler()}
                >
                    <ButtonBase aria-label="theme-icon"  sx={{ borderRadius: `${borderRadius}px` }} disableRipple={drawerOpen}>
                        {loading ? (
                            <>
                                <Skeleton
                                    variant="rectangular"
                                    sx={{ mt: '0px', mb: '0px,', background: theme.palette.secondary.main }}
                                    height={30}
                                />
                            </>
                        ) : (
                            <ListItemIcon
                                sx={{
                                    minWidth: level === 1 ? 36 : 18,

                                    color: isSelected ? iconSelectedColor : '#ff0000',
                                    ...(!drawerOpen &&
                                        level === 1 && {
                                            // borderRadius: `${borderRadius}px`,
                                            width: 56,
                                            height: 46,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: theme.palette.common.white,
                                            '&:hover': {
                                                bgcolor: mode === ThemeMode.DARK ? alpha(theme.palette.secondary.main, 1) : '#d4e8e1'
                                            },
                                            ...(isSelected && {
                                                bgcolor: mode === ThemeMode.DARK ? alpha(theme.palette.secondary.main, 1) : '#d4e8e1',
                                                '&:hover': {
                                                    bgcolor: mode === ThemeMode.DARK ? alpha(theme.palette.secondary.main, 1) : '#d4e8e1'
                                                }
                                            })
                                        })
                                }}
                            >
                                <img className="svgimg" style={{ width: '1.4em', height: '1.4em' }} src={item?.svg} alt="Your SVG Icon" />
                            </ListItemIcon>
                        )}
                    </ButtonBase>

                    {(drawerOpen || (!drawerOpen && level !== 1)) && (
                        <Tooltip title={item.title} disableHoverListener={!hoverStatus}>
                            <ListItemText
                            
                                primary={
                                    loading ? (
                                        <>
                                            <Skeleton
                                                variant="rectangular"
                                                sx={{ mt: '0px', mb: '0px,', background: theme.palette.secondary.main }}
                                                height={21}
                                            />
                                        </>
                                    ) : (
                                        <Typography
                                            ref={ref}
                                            noWrap
                                            overflow="hidden"
                                            textOverflow="ellipsis"
                                            variant={isSelected ? 'h5' : 'body1'}
                                            color="#212121"
                                            width={150}
                                            sx={{ fontSize: '16px', fontWeight: '500' }}
                                        >
                                            {item.title}
                                        </Typography>
                                    )
                                }
                                secondary={
                                    item.caption && (
                                        <Typography
                                            variant="caption"
                                            sx={{ ...theme.typography.subMenuCaption }}
                                            display="block"
                                            gutterBottom
                                        >
                                            {loading ? (
                                                <>
                                                    <Skeleton
                                                        variant="rectangular"
                                                        sx={{ mt: '15px', mb: '15px,', background: theme.palette.secondary.main }}
                                                        height={40}
                                                    />
                                                </>
                                            ) : (
                                                item.caption
                                            )}
                                        </Typography>
                                    )
                                }
                            />
                        </Tooltip>
                    )}

                    {drawerOpen && item.chip && (
                        <Chip
                            color={item.chip.color}
                            variant={item.chip.variant}
                            size={item.chip.size}
                            label={item.chip.label}
                            avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
                        />
                    )}
                </ListItemButton>
            ) : (
                <ListItemButton
                    component={Link}
                    to={item.url!}
                    target={itemTarget}
                    disabled={item.disabled}
                    sx={{
                        borderRadius: isParents ? `${borderRadius}px` : 0,
                        mb: isParents ? 0 : 0.5,
                        alignItems: 'flex-start',
                        backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                        py: 1,
                        pl: 2,
                        mr: isParents ? 1 : 0
                    }}
                    selected={isSelected}
                    onClick={() => itemHandler()}
                >
                    <ListItemIcon
                        sx={{
                            my: 'auto',
                            minWidth: !item?.icon ? 18 : 36
                        }}
                    >
                        {itemIcon}
                    </ListItemIcon>

                    <ListItemText
                        primary={
                            <Typography variant={isSelected ? 'h5' : 'body1'} color="inherit">
                                {item.title}
                            </Typography>
                        }
                        secondary={
                            item.caption && (
                                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )
                        }
                    />

                    {item.chip && (
                        <Chip
                            color={item.chip.color}
                            variant={item.chip.variant}
                            size={item.chip.size}
                            label={item.chip.label}
                            avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
                        />
                    )}
                </ListItemButton>
            )}
            </Navitems>
        </>
    );
};

export default NavItem;
